import { IonContent, IonPage, IonImg, useIonViewDidLeave } from '@ionic/react';
import { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { PdfContext } from '../components/PdfViewer';

const AppAcademy = () => {
  const { setModalVisible, setDesktopPdf, setMobilePdf } = useContext(PdfContext);
  const [swiper, setSwiper] = useState<SwiperCore>();
  // set the swiper slide to the first one when the component is mounted
  useIonViewDidLeave(() => {
    swiper?.slideTo(0);
  }, [swiper]);
  return (
    <>
      <IonPage>
        <IonContent fullscreen>
          <Swiper
            initialSlide={0}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            onSwiper={(swiper) => setSwiper(swiper)}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={0}
            centeredSlides={true}
            breakpoints={{
              768: {
                slidesPerView: 1.2,
                spaceBetween: -20
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: -120
              },
            }}
          >
            <SwiperSlide>
              <div className="container-inner app-academy">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#9c00ff', color: '#fff' }}>Học viện ứng dụng</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030', paddingTop: '0.1rem' }}>
                    <p>
                      Học viện ứng dụng đảm bảo rằng bạn biết cách sử dụng Tinder cũng như hiểu rõ trái
                      tim mình muốn gì. Học viện ứng dụng giới thiệu tới bạn tất cả những tính năng thú vị mà bạn có
                      thể đã bỏ lỡ (đúng vậy, việc thích và tương hợp từ một quốc gia khác hoàn toàn là một vấn đề
                      quan trọng) cùng với tính năng mới hấp dẫn nhất trên ứng dụng của chúng tôi - tính năng Khám phá. Sau khi lướt qua phần này, đừng ngạc nhiên vì đảm bảo bạn sẽ bỏ túi thêm hàng loạt tương hợp
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
            <div className="container-inner design-video">
              <div className="d-flex">
                <h1 className='container-title'>Heading of the video</h1>
                <div className='container-content'>
                  <div className="video-container">
                    <div className="thumbnail">
                      <IonImg src='assets/img/video-thumb.png'></IonImg>
                    </div>
                    <div className="description-outer">
                      <div className="description">
                        <h3 className='title'>
                          Video title
                        </h3>
                        <p>Video subtitle, this is a dummy description, lorem ipsum dolor sit amet.</p>
                      </div>
                      <a href="/">CLICK TO VIEW</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide> */}
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#ff00ae', color: '#fff' }}>Hồ sơ cá nhân</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop' >Giải pháp cho mọi vấn đề về hồ sơ Tinder - từ việc chọn ảnh phù hợp cho đến lời giới thiệu hoàn hảo!</p>
                    <IonImg src='assets/img/aa-profile-pro-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Giải pháp cho mọi vấn đề về hồ sơ Tinder - từ việc chọn ảnh phù hợp cho đến lời giới thiệu hoàn hảo!</p>
                      <button style={{ color: "#fff", background: "#ff00ae" }} onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_TheProfileProject.pdf");
                        setMobilePdf("/assets/pdf/VN_TheProfileProject(m).pdf");
                        setModalVisible(true);
                      }}>Trở thành chuyên gia</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#26e8c8', color: '#fff' }}>Giải thích về Tính năng Khám phá</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Lựa chọn sở thích, đam mê của bạn và kết nối với những người cùng gu.</p>
                    <IonImg src='assets/img/aa-explore-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Lựa chọn sở thích, đam mê của bạn và kết nối với những người cùng gu.</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_Explore.pdf");
                        setMobilePdf("/assets/pdf/VN_Explore(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#26e8c8" }}>Bắt đầu khám phá</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#298cfb', color: '#fff' }}>Các tính năng nổi bật trên Tinder</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Những tính năng hấp dẫn nhất chắc chắn mang tới cho bạn một trải nghiệm Tinder thú vị bậc nhất.</p>
                    <IonImg src='assets/img/aa-flex-thumb-01.png' style={{ objectPosition: 'bottom' }}></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Những tính năng hấp dẫn nhất chắc chắn mang tới cho bạn một trải nghiệm Tinder thú vị bậc nhất.</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_Features.pdf");
                        setMobilePdf("/assets/pdf/VN_Features(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#298cfb" }}>Khám phá ngay</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#ff5599', color: '#fff' }}>Làm thế nào để rắc muối cho cuộc trò chuyện thêm lôi cuốn</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Hãy trở thành người phá băng và mở đầu cuộc trò chuyện. Nâng cấp kỹ năng trò chuyện của bạn với những gợi ý thú vị này nhé!</p>
                    <IonImg src='assets/img/aa-dry-convos-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Hãy trở thành người phá băng và mở đầu cuộc trò chuyện. Nâng cấp kỹ năng trò chuyện của bạn với những gợi ý thú vị này nhé!</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_AvoidDryConvo.pdf");
                        setMobilePdf("/assets/pdf/VN_AvoidDryconvo(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#ff5599" }}>Bắt đầu nhắn tin</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </IonContent >
      </IonPage >
    </>
  );
};

export default AppAcademy;